import { RoutePermittedRole } from "shared/constants/AppConst";
import Appellate from "./appellate_page";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const appellateMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/appellateMessage",
    exact: true,
    element: isModuleAuthorized("Appellate Message") ? <Appellate /> : <Error403 />,
  }
];
